/**
 * The Resource filter on the Cleaning / Equipment Tasks and Pending Actions tabs
 * (z8nrz7fgzw). A resource is a person, as in the Resource Center; the filter
 * narrows the tab to the tasks assigned to them.
 */

/** Role slug of the Supervisor system role (`GET /auth/me` roles). */
export const SUPERVISOR_ROLE = 'supervisor'

/**
 * Super Admin and supervisors open the tabs on everyone's tasks; everyone else
 * on their own. Only a default: the filter can always be changed.
 */
export function seesAllTasksByDefault(viewer: { isSuperAdmin: boolean; roles: readonly string[] }): boolean {
  return viewer.isSuperAdmin || viewer.roles.includes(SUPERVISOR_ROLE)
}

/** The filter a viewer opens on: null for everyone, else their own user id. */
export function defaultResourceId(viewer: {
  isSuperAdmin: boolean
  roles: readonly string[]
  userId: string | null | undefined
}): string | null {
  if (seesAllTasksByDefault(viewer)) return null
  return viewer.userId ?? null
}
